module.exports = __webpack_public_path__ + "media/images/emblems/Marthalen-blazon-136060fba49c5ad907f4b3563d58c95e.svg";